import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import Loader from "../../atomic/Loader/Loader";
import Panel from "../../atomic/Panel/Panel";
import InputEdit, {
  FileUploadEdit,
  TextEdit,
  RangeEdit,
  CheckboxesEdit
} from "../../atomic/InputEdit/InputEdit";
import Button from "../../atomic/Button/Button";
import { Link } from "react-router-dom";
import Slider from "../../atomic/Slider/Slider";
import InputText from "../../atomic/InputText/InputText";
import TextArea from "../../atomic/TextArea/TextArea";
import CheckboxGroup from "react-checkbox-group";
import RichTextEditor, {
  Converter
} from "../../atomic/RichTextEditor/RichTextEditor";

const Header = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  background-color: rgb(234, 234, 234);
  width: 100%;
  border-bottom: 1px solid rgb(196, 196, 196);
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 20px;
  svg {
    margin-right: 10px;
  }
`;

const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  input::placeholder {
    color: ${props => props.theme.borderColor};
  }
  label {
    width: 100%;
    color: rgba(0, 0, 0, 0.54);
    display: inline-block;
    font-size: 13px;
    line-height: 20px;
  }
  button {
    background-color: rgb(2, 82, 107);
    color: white;
    cursor: pointer;
    font-size: 12px;
    padding: 5px 10px;
    text-decoration: none;
    min-width: 100px;
    font-weight: 600;
  }
`;

const Field = styled.div``;
const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default withTheme(({ theme, locations, save, saving, lesson }) => {
  const [less, setLess] = useState(lesson);
  const [richTextState, setRichTextState] = useState(
    Converter.convertToState(lesson.description || "")
  );
  const makeLesson = () => {
    return { ...less, description: Converter.convertFromState(richTextState) };
  };
  return (
    <Root>
      <Header>
        <div>
          <Link to="/lessons">
            {" "}
            <Button>
              <FontAwesomeIcon
                icon={["fas", "arrow-left"]}
                size="1x"
                color={theme.color1}
              />{" "}
              Back to Lessons
            </Button>
          </Link>
        </div>
        <div></div>
      </Header>
      <Panel>
        <Field>
          <label>Name</label>
          <InputText
            value={less.name}
            placeholder="Enter Lesson Name"
            onChange={e => setLess({ ...less, name: e.target.value })}
          />
        </Field>
        <Field>
          <label>Price</label>
          <InputText
            value={less.price || ""}
            placeholder="Enter the lesson's price (e.g. $120 per term)"
            onChange={e => setLess({ ...less, price: e.target.value })}
          />
        </Field>
        <Field>
          <label>Description</label>
          <RichTextEditor
            id="LessonDescription"
            editorState={richTextState}
            onChange={st => setRichTextState(st)}
          />
        </Field>
        <Field>
          <label>Age range</label>
          <Slider
            from={less.ageFrom || 0}
            to={less.ageTo || 18}
            onChange={(from, to) => {
              setLess({ ...less, ageFrom: from, ageTo: to });
            }}
          />
        </Field>
        <Field>
          <label>Runs in locations</label>
          <div>
            <CheckboxGroup
              name="fruits"
              value={less.locations || []}
              onChange={v => {
                console.log("AAA", v);
                setLess({ ...less, locations: v });
              }}
            >
              {Checkbox => (
                <>
                  {locations
                    .filter(l => l.status !== "deleted")
                    .map(l => ({ key: l.id, name: l.address }))
                    .map(o => (
                      <label>
                        <Checkbox value={o.key} /> {o.name}
                      </label>
                    ))}
                </>
              )}
            </CheckboxGroup>
          </div>
        </Field>
        <Buttons>
          {!saving && (
            <button
              onClick={() => {
                save(makeLesson());
              }}
            >
              Save
            </button>
          )}
          {saving && (
            <button>
              <FontAwesomeIcon
                icon={["fas", "spinner"]}
                size="1x"
                color={"white"}
                spin
              />
            </button>
          )}
        </Buttons>
      </Panel>
    </Root>
  );
});
